import { Components, Theme } from '@mui/material/styles';

const tabTheme: Components<Theme>['MuiTab'] = {
  styleOverrides: {
    root: ({ theme }) => ({
      '&[aria-label="standard"].MuiTab-root': {
        minHeight: "30px",
        textTransform: "none",
        fontWeight: "bold",
        background: theme.palette.warmBlue,
        marginTop: 0,
        '&.Mui-selected': {
          color: theme.palette.neutralWhite,
        },
        '&:not(.Mui-selected)': {
          color: theme.palette.grey.A500,
          fontWeight: "normal",
        },
      }
    }),
  },
};

export default tabTheme;
